import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import classNames from 'classnames';

import { Bookset } from 'rebook/apps/catalog/models';
import * as LandingActions from 'rebook/apps/landing/actions/LandingActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import { URLS } from 'rebook/apps/base/constants';
import TopBlock from 'rebook/apps/landing/components/TopBlock';
import NoveltyBooksBlock from 'rebook/apps/landing/components/NoveltyBooksBlock';
import BusinessBooksBlock from 'rebook/apps/landing/components/BusinessBooksBlock';
import FreeBooksBlock from 'rebook/apps/landing/components/FreeBooksBlock';
import AllBooksBlock from 'rebook/apps/landing/components/AllBooksBlock';
import LatestBooksetBlock from 'rebook/apps/landing/components/LatestBooksetBlock';
import BottomBlock from 'rebook/apps/landing/components/BottomBlock';
import SeoText from 'rebook/apps/landing/components/SeoText';
import AllAudioBooksBlock from 'rebook/apps/landing/components/AllAudioBooksBlock';


class LandingView extends React.Component {
  componentDidMount() {
    this.props.LandingActions.fetchInitialData();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(LandingActions.fetchInitialData());
  }

  render() {
    const { landing, user, booksPerSubscriptionCounter } = this.props;
    const { noveltyBookset, businessBookset, freeBooksBookset, latestBooksets, audioBookset, genres } = landing;

    if (user) {
      return <Redirect to={URLS.dashboard} />;
    }

    let noveltyBooksetModel, businessBooksetModel;

    if (noveltyBookset && businessBookset) {
      noveltyBooksetModel = new Bookset(noveltyBookset.bookset);
      businessBooksetModel = new Bookset(businessBookset.bookset);
    }
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <TopBlock
          totalBooksCounter={booksPerSubscriptionCounter.total}
          audioBooksCounter={booksPerSubscriptionCounter.audio} />
        <div className="section">
          <NoveltyBooksBlock noveltyBookset={noveltyBookset} noveltyBooksetModel={noveltyBooksetModel} />
          <BusinessBooksBlock
            businessBookset={businessBookset}
            businessBooksetModel={businessBooksetModel}
            genres={genres} />
          <AllAudioBooksBlock
            audioBooks={audioBookset}
            audioBooksCounter={booksPerSubscriptionCounter.audio} />
          <FreeBooksBlock freeBooksBookset={freeBooksBookset} />
          <AllBooksBlock />
          <LatestBooksetBlock latestBooksets={latestBooksets} />
          <BottomBlock />
          <SeoText />
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    landing: state.landing,
    catalogIndex: state.catalogIndex,
    payments: state.payments,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    LandingActions: bindActionCreators(LandingActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingView);
